import _ from 'lodash'
import axios from 'axios'
import { layoutId } from '~/utils/helper'

export const actions = {

    async nuxtServerInit({ dispatch, commit, state }, { req, res, app }) {
        try {
            // 用户登录记录 sessionx
            if (req.session) {
                req.session.authUser && commit('SET_USER', req.session.authUser)
            }
            dispatch('setMenuList')
        } catch (e) {
            console.log(e)
        }
    },

    /**
     * 登陆
     * @param commit
     * @param username
     * @param password
     * @returns {Promise.<void>}
     */
    async login({ commit }, { username, password }) {
        // try {
        //     console.log(username, password)
        //     let{ data: { payload } } = await LoginInfoQ(this.$axios)
        //                                         .create({
        //                                             username,
        //                                             password
        //                                         })
        //     if (payload.code !== 200) {
        //         throw payload.info || '登陆失败'
        //     }
        //     let { info: { layout_info } } = payload
        //     commit('SET_USER', payload)
        // } catch (error) {
        //     if (error.response && error.response.status !== 200) {
        //         throw new Error(error.response.messge ? error.response.messge : 'Bad credentials')
        //     }
        //     throw error
        // }
    },

    /**
     * 退出
     * @param commit
     * @returns {Promise.<void>}
     */
    async logout({ commit }) {
        await LogoutInfoQ(this.$axios)
                .create()
        commit('SET_USER', null)
        this.$router.push({path: '/login'})
    },

    setMenuList({ commit }) {
        
    }
}



// WEBPACK FOOTER //
// ./store/actions.js